var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 14.56c0-5.554 3.894-9.06 8.5-9.06s8.5 3.506 8.5 9.06c0 3.71-2.148 6.697-4.51 8.852a22.6 22.6 0 0 1-3.961 2.872 25.24 25.24 0 0 1-4.004-3.039C9.632 21.005 7.5 18.017 7.5 14.56m7.799 14.766L16 28zl1.35.026L16 28l.65 1.352h.001l.004-.002.009-.005.029-.014.1-.05q.128-.065.351-.185a25.58 25.58 0 0 0 4.867-3.468C24.648 23.223 27.5 19.49 27.5 14.56 27.5 7.39 22.303 2.5 16 2.5S4.5 7.39 4.5 14.56c0 4.703 2.868 8.435 5.475 10.875a28.2 28.2 0 0 0 4.837 3.616 17 17 0 0 0 .445.253l.029.015.008.005.003.001zM17 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    clipRule: "evenodd"
  })));
};
export default SvgLocationPin;